module.exports = __webpack_public_path__ + "static/media/icon-texts-white.08a80a70.svg";